

























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { ListsEnum } from '@/modules/shared/enums'
import { mapObjectVuetifySelect } from '@/modules/shared/helpers'
import { AppState } from '@/stores/appStore'
import Rules from '@/plugins/validations'
import SalesUserFile from '@/modules/sales/models/salesuser/file'
import { SalesState } from '../../store'

@Component
export default class SalesUserFileUploadForm extends Vue {
  @Prop({ required: true })
  private salesId!: number

  private errorMessage = ''
  private saving = false

  private files: Array<{ reading: boolean; completed: number; file: SalesUserFile }> = []

  private categories = mapObjectVuetifySelect(AppState.listsByName[ListsEnum.SALES_FILE_CATEGORIES]!, true).sort((a, b) => a.text.localeCompare(b.text))

  private removeFile (index: number) {
    this.files.splice(index, 1)
  }

  private processFileSelection () {
    const chosenFiles: FileList = (this.$refs.fileInput as HTMLInputElement).files!

    if (chosenFiles.length === 0) {
      this.files = this.files.splice(0, this.files.length)
      return
    }

    for (let i = 0; i < chosenFiles.length; i++) {
      this.readFile(chosenFiles[i])
    }
  }

  private readFile (f: File) {
    const reader = new FileReader()

    const newItem: { reading: boolean; completed: number; file: SalesUserFile } = {
      reading: false,
      completed: 0,
      file: new SalesUserFile({ name: f.name, categoryId: 0, salesId: this.salesId })
    }

    reader.onloadstart = (e) => {
      newItem.reading = true

      this.files.push(newItem)
    }

    reader.onprogress = (e) => {
      if (!e.lengthComputable) {
        return
      }

      newItem.completed = Math.round((e.loaded / e.total) * 100)
    }

    reader.onloadend = (e) => {
      newItem.reading = false
      newItem.file.contents = reader.result as string
    }

    reader.readAsBinaryString(f)
  }

  public async handleSubmit () {
    if (this.saving || !this.files.length || this.files.some(i => i.reading)) {
      return
    }

    this.saving = true
    this.errorMessage = ''

    await Promise.all(this.files.map(async (i) => {
      try {
        await SalesState.SaveUserFile({
          file: i.file,
          callback: (e: ProgressEvent) => {
            i.completed = Math.round((e.loaded * 100) / e.total)
            i.reading = i.completed < 100
          }
        })
      } catch (err) {
        console.log(err.message)
        this.errorMessage = err.message
      }
    }))

    this.saving = false
    if (!this.errorMessage.length) {
      Vue.set(this, 'files', [])
      this.handleClose()
    }
  }

  public handleClose (): void {
    this.$emit('dialog:close')
  }
}
